import React from 'react'
import ReactDOM from 'react-dom'
import Quote from '../../../site/layout/component/Primitive/Quote'
import ThemeContext from '../../../site/layout/component/Theme/ThemeContext'

const debug = require('debug')('summaryWrapper')

export default () => {
  debug('init')
  document.addEventListener('DOMContentLoaded', () => {
    const theme = document.querySelector('body').dataset.theme

    document.querySelectorAll('.js-quotes').forEach(appNode => {
      const props = JSON.parse(appNode.getAttribute('data-props') || '{}')
      ReactDOM.render(
        <ThemeContext.Provider value={theme}>
          <Quote {...props} />
        </ThemeContext.Provider>,
        appNode
      )
    })
  })
}
